import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NO_DATA_LANG_LABEL } from '../../constants/ads';
import { GOAL_TYPE } from '../../constants/goals';
import LoadingTableState from './LoadingTableState';
import AdCampaignWithIcon from './AdCampaignWithIcon';
import CostPerCampaignLabel from './CostPerCampaignLabel';
import GoalTypePerCampaignValue from './GoalTypePerCampaignValue';

const NO_DATA_DISPLAY = /*#__PURE__*/_jsx(FormattedMessage, {
  message: NO_DATA_LANG_LABEL
});

export default function AdSpendTableBody({
  goalTarget,
  adSpendPerCampaign,
  adSpendLoadingPercentage,
  adCampaigns
}) {
  const {
    goalType
  } = goalTarget;

  const getAmountSpendPerCampaignId = adCampaignId => {
    const adSpendForCampaign = adSpendPerCampaign.get(adCampaignId);

    if (!adSpendForCampaign || isNaN(adSpendForCampaign.adSpend) || !adSpendForCampaign.currencyCode) {
      return NO_DATA_DISPLAY;
    }

    return /*#__PURE__*/_jsx(FormattedCurrency, {
      currencyCode: adSpendForCampaign && adSpendForCampaign.currencyCode,
      value: adSpendForCampaign.adSpend
    });
  };

  const getGoalTypeDataPerCampaignId = adCampaignId => {
    let value;
    let format;
    const goalTypeDataPerCampaign = adSpendPerCampaign.get(adCampaignId) && adSpendPerCampaign.get(adCampaignId).goalTypeCount;

    if (goalTypeDataPerCampaign && typeof goalTypeDataPerCampaign === 'object') {
      format = goalTypeDataPerCampaign.currencyCode;
      value = goalTypeDataPerCampaign.amount;
    } else {
      value = goalTypeDataPerCampaign;
    }

    return {
      value,
      format
    };
  };

  const isGoalTypeCostPerContactLifecycle = goalType === GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE;
  const isAdSpendLoading = adSpendLoadingPercentage < 100;
  if (isAdSpendLoading) return /*#__PURE__*/_jsx("tbody", {
    children: /*#__PURE__*/_jsx(LoadingTableState, {
      columns: isGoalTypeCostPerContactLifecycle ? 3 : 4
    })
  });
  return /*#__PURE__*/_jsx("tbody", {
    children: adCampaigns && adCampaigns.map(adCampaign => {
      const goalTypeDataObject = getGoalTypeDataPerCampaignId(adCampaign.adCampaignId);
      return /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(AdCampaignWithIcon, {
            adAccountId: adCampaign.adAccountId,
            adCampaignId: adCampaign.adCampaignId,
            adCampaignName: adCampaign.name,
            adCampaignNetwork: adCampaign.adNetwork
          })
        }), /*#__PURE__*/_jsx("td", {
          children: getAmountSpendPerCampaignId(adCampaign.adCampaignId)
        }), /*#__PURE__*/_jsx("td", {
          className: isGoalTypeCostPerContactLifecycle ? 'text-right' : undefined,
          children: /*#__PURE__*/_jsx(GoalTypePerCampaignValue, {
            goalType: goalTarget.goalType,
            goalTypeData: getGoalTypeDataPerCampaignId(adCampaign.adCampaignId)
          })
        }), !isGoalTypeCostPerContactLifecycle && /*#__PURE__*/_jsx("td", {
          className: "text-right",
          children: /*#__PURE__*/_jsx(CostPerCampaignLabel, {
            adSpendPerCampaign: adSpendPerCampaign,
            adCampaignId: adCampaign.adCampaignId,
            goalTypeDataObject: goalTypeDataObject
          })
        })]
      }, adCampaign.adCampaignId);
    })
  });
}